import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appIcons, appImages } from "../../assets";
import GlobalButton from "../../components/button";
import ProductCartCard from "../../components/cards/ProductCartCard";
import AppFooter from "../../components/footer";
import LoginDialog from "../../components/loginDialog/index.js";
import NavBar from "../../components/NavBar/index.js";
import { CURRENCY } from "../../lib/variables/index.js";
import { renderSubTotal } from "../../utils/index.js";
import ReactGA from "react-ga4";

const ProductCart = () => {
  const openLoginDialog = useRef();
  const navigate = useNavigate();
  const cartData = useSelector((state) => state.cartReducer.cartData);
  const userData = useSelector((state) => state.userReducer.user);

  return (
    <>
      <NavBar />
      <Box
        marginTop={5}
        height={{ xs: "60vh", sm: "100vh" }}
        display="flex"
        flexDirection="column"
        position={"relative"}
        sx={{
          //   background: palette.gradient.background,
          backgroundImage: `url(${appImages.pdDetailBgImg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <Header /> */}
      </Box>
      <Box position={"absolute"} top={{ xs: 130, sm: 150 }} left={0} right={0}>
        <Container
          maxWidth={"lg"}
          sx={{
            // maxWidth: "1100px !important",
            position: "relative",
            zIndex: 999,
          }}
        >
          <GlobalButton
            handleClickBtn={() => navigate(-1)}
            variant={"outlined"}
            btnText={"goBack"}
            startIcon={<img src={appIcons.whiteArrowBackIcon} width={30} />}
            styleProps={{
              color: "text.white",
              borderColor: "text.white",
            }}
          />

          <Typography
            variant="heading_sec"
            component={"h1"}
            textAlign={"center"}
            color={"text.white"}
            lineHeight={"normal"}
            mb={1}
          >
            {t("cartPageHead")}
          </Typography>
          <Typography
            variant="heading_pr"
            component={"h1"}
            maxWidth={700}
            margin={"auto"}
            textAlign={"center"}
            color={"text.white"}
            lineHeight={"normal"}
            mb={5}
          >
            {t("cartPageSubHead")}
          </Typography>

          {cartData?.length === 0 && (
            <Stack gap={2} alignItems={"center"}>
              <Typography
                fontSize={20}
                textAlign={"center"}
                color={"text.white"}
                lineHeight={"normal"}
                mt={2}
              >
                {t("noItemsInCart")}
              </Typography>
              <GlobalButton
                btnText={"continueShopping"}
                handleClickBtn={() => navigate("/")}
                styleProps={{
                  backgroundColor: "text.orangeRed",
                  width: "auto",
                  height: 50,
                  fontSize: "1rem",
                  textTransform: "uppercase",
                }}
              />
            </Stack>
          )}

          <Grid container spacing={2} my={4}>
            {cartData?.map((val, index) => {
              return (
                <Grid key={index} item xs={12} sm={4} md={3}>
                  <ProductCartCard product={val} index={index} />
                </Grid>
              );
            })}
          </Grid>
          {cartData?.length > 0 && (
            <>
              <Stack my={3}>
                <Typography variant="body1" textTransform={"capitalize"}>
                  {t("totalCost")}
                </Typography>
                <Typography variant="h4">
                  {`${CURRENCY} ${renderSubTotal(cartData)}`}
                </Typography>
                <Stack direction={"row"} spacing={2} mt={2}>
                  <GlobalButton
                    btnText={"checkOut"}
                    handleClickBtn={() => {
                      if (!userData) {
                        openLoginDialog.current.openDialog();
                      } else {
                        navigate("/check-out");
                        ReactGA.event({
                          category: "Ecommerce",
                          action: "Checkout Started",
                        });
                      }
                    }}
                    styleProps={{
                      backgroundColor: "text.orangeRed",
                      width: 150,
                      height: 50,
                      borderRadius: 0,
                      boxShadow: "none",
                    }}
                  />
                  <GlobalButton
                    variant={"outlined"}
                    btnText={"cancel"}
                    handleClickBtn={() => navigate("/")}
                    styleProps={{
                      width: 150,
                      height: 50,
                      borderRadius: 0,
                      boxShadow: "none",
                      color: "text.orangeRed",
                      borderColor: "text.orangeRed",
                    }}
                  />
                </Stack>
              </Stack>
            </>
          )}
        </Container>
        <LoginDialog ref={openLoginDialog} />
        <AppFooter bgcolor={true} />
      </Box>
    </>
  );
};

export default ProductCart;
